/**
 * Abstract base component class
 * All UI components extend this
 */

import type { UnsubscribeFunction } from '../types';
import { escapeHtml } from '../utils/dom';

export abstract class BaseComponent {
  protected container: HTMLElement;
  protected subscriptions: UnsubscribeFunction[] = [];

  constructor(container: HTMLElement) {
    this.container = container;
  }

  abstract render(): void;

  destroy(): void {
    // Cleanup subscriptions
    this.subscriptions.forEach((unsubscribe) => unsubscribe());
    this.subscriptions = [];

    // Clear container
    this.container.innerHTML = '';
  }

  protected escapeHtml(text: string): string {
    return escapeHtml(text);
  }

  protected showResponse(elementId: string, status: number, data: any, headers?: Headers): void {
    const el = document.getElementById(elementId);
    if (!el) return;

    el.style.display = 'block';

    const statusClass = status >= 200 && status < 300 ? 'success' : status >= 400 ? 'error' : 'info';
    const rateLimitInfo = headers
      ? `
        <div style="margin-top: 10px; font-size: 12px; color: #666;">
          Rate Limit: ${headers.get('X-RateLimit-Limit') || 'N/A'} |
          Remaining: ${headers.get('X-RateLimit-Remaining') || 'N/A'} |
          Retry-After: ${headers.get('Retry-After') || 'N/A'}s
        </div>
      `
      : '';

    el.innerHTML = `
      <h4>Response</h4>
      <span class="status ${statusClass}">HTTP ${status}</span>
      <pre>${JSON.stringify(data, null, 2)}</pre>
      ${rateLimitInfo}
    `;
  }
}
